import { SYNCABLE_META } from "$global-providers/rxdb-provider/collections/common";
import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { FHIR_RESOURCE_SCHEMA } from "./common";

export enum ClinicalResourceSubmissionStatus {
  Staged = "Staged",
  Submitted = "Submitted",
}

export const RXDB_PATIENT_CLINICAL_RESOURCE_COLLECTION_NAME =
  "patient-clinical-resources";

export const PATIENT_CLINICAL_RESOURCE_SCHEMA_LITERAL = {
  title: "patient clinical resource schema",
  version: 7,
  description:
    "Stores of FHIR-encoded clinical resources associated with a particular patient(e.g., symptoms, test results).",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 200,
      description:
        "Primary key for the resource. Format: {externalCodingId}-{patientId}-{submissionStatus}",
    },
    patient: {
      type: "object",
      properties: {
        id: {
          type: "string",
        },
      },
      required: ["id"],
    },
    fhirResource: FHIR_RESOURCE_SCHEMA,
    submissionStatus: {
      type: "string",
      enum: Object.values(ClinicalResourceSubmissionStatus),
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "patient", "fhirResource", "submissionStatus", "meta"],
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(
  PATIENT_CLINICAL_RESOURCE_SCHEMA_LITERAL,
);

export type PatientClinicalResource = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PATIENT_CLINICAL_RESOURCE_SCHEMA: RxJsonSchema<PatientClinicalResource> =
  PATIENT_CLINICAL_RESOURCE_SCHEMA_LITERAL;
